import { first } from 'lodash';
import { useSelector } from 'react-redux';
import { getOrganization } from 'store/organizations/selectors';
import {
  Subscription,
  SubscriptionStatus,
} from 'store/subscription/interfaces';
import { useGetSubscriptionsQuery } from 'store/subscription/subscription';

export default function useGetSubscription() {
  const organization = useSelector(getOrganization);
  const {
    data: subscriptionData = {
      'hydra:member': [] as Subscription[],
    },
    isLoading: subscriptionsLoading,
    isError: subscriptionsError,
  } = useGetSubscriptionsQuery({ organization: organization.id });
  const subscription = (() => {
    const activeSubscriptions = subscriptionData['hydra:member'].find(
      (subscriptionItem) =>
        subscriptionItem.status === SubscriptionStatus.active,
    );
    if (activeSubscriptions) {
      return activeSubscriptions;
    }

    const awaitingSubscriptions = subscriptionData['hydra:member'].find(
      (subscriptionItem) =>
        subscriptionItem.status === SubscriptionStatus.awaiting,
    );

    return awaitingSubscriptions ?? first(subscriptionData['hydra:member']);
  })();

  return {
    subscription,
    subscriptionsLoading,
    subscriptionsError,
  };
}
